var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17151",
    "data-name": "Group 17151",
    transform: "translate(0 0.153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(0 -0.153)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(2 3.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15804",
    "data-name": "Group 15804",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15803",
    "data-name": "Group 15803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8007",
    "data-name": "Path 8007",
    d: "M7.03,64.963c2.172,1.839,5.982,5.074,7.1,6.083a.662.662,0,0,0,.957,0c1.121-1.01,4.931-4.246,7.1-6.085a.329.329,0,0,0,.046-.455A1.309,1.309,0,0,0,21.2,64H8.019a1.309,1.309,0,0,0-1.035.508A.329.329,0,0,0,7.03,64.963Z",
    transform: "translate(-6.7 -64)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8008",
    "data-name": "Path 8008",
    d: "M15.631,126.442a.328.328,0,0,0-.352.048c-2.408,2.042-5.482,4.658-6.449,5.53a1.335,1.335,0,0,1-1.84,0c-1.031-.929-4.482-3.863-6.448-5.529a.33.33,0,0,0-.543.251v8.29a1.32,1.32,0,0,0,1.319,1.319H14.5a1.32,1.32,0,0,0,1.318-1.319v-8.29A.329.329,0,0,0,15.631,126.442Z",
    transform: "translate(0 -124.483)",
    fill: "#3f2566"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.3476fac71f6237e5dfe92124aa4d1d1a.svg";
export { ForwardRef as ReactComponent };